import { css } from 'styled-jsx/css';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { colors } from '../Theme';

const styles = css`
  .card {
    display: flex;
    border-radius: 30px 0 30px 0;
    box-sizing: border-box;
    flex-direction: column;
    flex-grow: 1;
    background: rgba(255, 255, 255, 0.95);
    height: auto;
    margin: 0;
    padding: 0;
    width: 100%;
    box-shadow: 5px 5px 16px 0 rgba(121, 121, 121, 0.2);
  }
  .card--secondary {
    background-color: ${colors.ywgPinkishOrange};
    box-shadow: 5px 5px 16px 0 rgba(${colors.ywgPinkishOrangeRgb}, 0.5);
    color: #ffffff;
  }
  .card--squared {
    border-radius: 0;
  }
  .card--plane {
    background: #ffffff 0 -10px url('/static/images/plane-1.svg') no-repeat;
  }
`;

const Card = ({
  id,
  squared,
  secondary,
  plane,
  children,
  className,
  ...props
}) => {
  const cardClasses = classnames(className, 'card', {
    'card--squared': squared,
    'card--secondary': secondary,
    'card--plane': plane
  });

  return (
    <div id={id} className={cardClasses} {...props}>
      {children}
      <style jsx>{styles}</style>
    </div>
  );
};

Card.propTypes = {
  id: PropTypes.string,
  secondary: PropTypes.bool,
  squared: PropTypes.bool,
  plane: PropTypes.bool,
  className: PropTypes.string
};

export default Card;
